/**
 * Las demás fotos de una oferta, debajo de su portada en la ficha.
 *
 * La portada ya se cambiaba con un clic; el resto de la galería sólo vivía en
 * el asistente y en la ficha no se veía que existiera. Aquí, una tira: pulsar
 * una la hace portada, su ✕ la quita y el «+» añade varias de golpe. Son
 * acciones de un clic, como la portada —el patrón de las fichas deja ésas en
 * la ficha y el resto en el asistente—.
 *
 * La comparten la ficha de una oferta y la de un servicio con reserva.
 */
import { useState } from 'react'
import { IconPlus, IconX } from '@tabler/icons-react'
import { useI18n } from '../../../lib/i18n'
import { ImageLibraryPickerDialog } from '../../ImageLibraryPickerDialog'

/** Las mismas que acepta el servidor en `offers.images`. */
export const MAX_RECORD_PHOTOS = 8

export function RecordPhotoStrip({ projectId, token, images, busy, onChange }: {
  projectId: string
  token: string
  /** Todas, con la portada primero. */
  images: string[]
  busy: boolean
  onChange: (images: string[]) => void
}) {
  const { t } = useI18n()
  const [picking, setPicking] = useState(false)
  /* Sin portada no hay tira: la primera foto se pone en la portada. */
  if (!images[0]) return null
  const rest = images.slice(1)
  const room = MAX_RECORD_PHOTOS - images.length
  return (
    <div className="dash-photo-strip" aria-label={t('offers.photos.label')}>
      {rest.map((url) => (
        <span key={url} className="dash-photo-strip-item">
          <button type="button" className="dash-photo-strip-thumb" disabled={busy} title={t('offers.photos.makeCover')}
            aria-label={t('offers.photos.makeCover')}
            onClick={() => onChange([url, ...images.filter((image) => image !== url)])}>
            <img src={url} alt="" loading="lazy" />
          </button>
          <button type="button" className="dash-photo-strip-remove" disabled={busy} aria-label={t('offers.photos.remove')} title={t('offers.photos.remove')}
            onClick={() => onChange(images.filter((image) => image !== url))}>
            <IconX size={11} />
          </button>
        </span>
      ))}
      {room > 0 ? (
        <button type="button" className="dash-photo-strip-add" disabled={busy} aria-label={t('offers.photos.add')} title={t('offers.photos.add')} onClick={() => setPicking(true)}>
          <IconPlus size={16} />
        </button>
      ) : null}
      {picking ? (
        <ImageLibraryPickerDialog
          token={token}
          projectId={projectId}
          multiple={{
            max: room,
            onSelectMany: (urls) => {
              setPicking(false)
              const added = urls.filter((url) => !images.includes(url))
              if (added.length) onChange([...images, ...added].slice(0, MAX_RECORD_PHOTOS))
            },
          }}
          onClose={() => setPicking(false)}
        />
      ) : null}
    </div>
  )
}
